export enum ProductType {
  AirAmbulance = 'AirAmbulance',
  DutyOfCare = 'DutyOfCare',
  TravelLicense = 'TravelLicense',
  KidnapAndExtortion = 'KidnapAndExtortion',
  SecurityResponse = 'SecurityResponse',
  Unknown = 'Unknown',
}
